/* eslint-disable no-unused-vars */
import React, { useEffect } from "react";
import Amount from "Widgets/withdraw_amount";
import Method from "Widgets/withdraw_method";
import { CratePayingMethod, TaxInfoModal, UpdateSelectedAccount } from "Widgets/withdraw_modals/index.js";
import "./withdraw.page.scss";
import { WithdrawModalsProvider } from "Widgets/withdraw_modals/context";
import { useDispatch } from "react-redux";
import { taxActions } from "../store";
import "./withdraw.page.scss";

export const WithdrawPage = () => {
	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(taxActions.initFetch());
	}, []);
	return (
		<div className="withdraw">
			<div className="withdraw__amount">
				<Amount />
			</div>
			<div className="withdraw__method">
				<Method />
			</div>
			<WithdrawModalsProvider>
				<CratePayingMethod />
				<UpdateSelectedAccount />
				<TaxInfoModal />
			</WithdrawModalsProvider>
		</div>
	);
};
